// extracted by mini-css-extract-plugin
export default {"form":"FooterForm_form__KjneE","input-group":"FooterForm_input-group__NAdYV","input":"FooterForm_input__Ggx7j","button":"FooterForm_button__kpPas"};